export var IotDevicesModalTypes;
(function (IotDevicesModalTypes) {
    IotDevicesModalTypes[IotDevicesModalTypes["SensorBatchModal"] = 0] = "SensorBatchModal";
    IotDevicesModalTypes[IotDevicesModalTypes["SensorModal"] = 1] = "SensorModal";
})(IotDevicesModalTypes || (IotDevicesModalTypes = {}));
